<div align="right">
  <button  mat-raised-button color="accent" (click)="logout()">
    <mat-icon>logout</mat-icon>
    </button>
</div>
<div class="container">
    <div class="row" style="margin-top: 3%;">

      <div class="col-5">
        <h6>Seleccionar una encuesta</h6>
        <div *ngIf="listEncuesta">
          <select class="custom-select" id="gr" [(ngModel)]="selectEncuesta"
            (change)="encuestaSeleccionada($event.target.value)">
            <option class="d-none d-sm-block d-md-block" selected disabled="true">SELECCIONE UNA ENCUESTA
            </option>
            <ng-container *ngFor="let encuesta of listEncuesta">
              <option [value]="encuesta.encuesta_id" name="selectAgentReport">{{encuesta.nombre}}</option>
            </ng-container>
          </select>
        </div>
      </div>
      <div class="col-5">
        <h6>Seleccione el tipo de reporte</h6>
        <div *ngIf="listTipo">
          <select class="custom-select" id="gr" [(ngModel)]="selectTipo"
            (change)="tipoReporteSeleccionado()">
            <option class="d-none d-sm-block d-md-block" value="SELECCIONE UN TIPO" disabled>SELECCIONE UN TIPO
            </option>
            <ng-container *ngFor="let tipo of listTipo">
              <option [ngValue]="tipo.nombre_reporte" name="nameversion">{{tipo.nombre_reporte}}</option>
            </ng-container>
          </select>
        </div>
      </div>
      <div class="col-2" style="margin-top: 3%;">
        <button type="button" class="btn btn-primary" (click)="openModal(template)">Seleccionar </button>
      </div>
    </div>

    <ng-template #template>
        <div class="modal-header">
            <h4 class="modal-title pull-left">{{selectTipo}}</h4>
            <button type="button" class="close pull-right" aria-label="Closse" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div *ngIf="selectTipo=='Reporte personalizado de datos'">
              <div class="input-group mb-3"  *ngFor="let campo of listCampos">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <div class="form-check" >
                      <input type="checkbox" class="form-check-input" id="dropdownCheck" [(ngModel)]="campo.habilitado">
                      <label class="form-check-label" for="dropdownCheck">
                          {{campo.campo}}
                      </label>
                    </div>
                  </div>
                </div>
                  <select class="browser-default custom-select" id="gr"  [(ngModel)]="campo.seleccionado" >

                    <option class="d-none d-sm-block d-md-block" selected disabled="true">SELECCIONE UNA OPCION</option>
                    <option *ngFor="let opcion of campo.opciones" [ngValue]=opcion name="selectOption">{{opcion}}</option>

                  </select>
              </div>
            </div>
            <div *ngIf="selectTipo=='Reporte individual'">
            <!--     <p>Ingresa el registro estudiantil</p>
           <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">#</span>
                <input [(ngModel)]="registroEstudiantil" type="text" class="form-control" placeholder="Registro Estudiantil" aria-label="Username" aria-describedby="basic-addon1">
              </div>

           -->
           <h6>Seleccione el registro estudiantil</h6>
           <div *ngIf="listCarnets">
             <select class="custom-select" id="basic-addon1" [(ngModel)]="registroEstudiantil"
              >
               <option class="d-none d-sm-block d-md-block" selected disabled="true">SELECCIONE UNA REGISTRO
               </option>
               <ng-container *ngFor="let tipo of listCarnets">
                 <option [ngValue]="tipo.registro" name="nameversion">{{tipo.registro}}</option>
               </ng-container>
             </select>
           </div>
<!--
  agregado para desplegar carnets
-->
            </div>
            <div *ngIf="selectTipo=='Reporte general de datos'">
              <p>Generar reporte general de datos</p>
            </div>
            <div *ngIf="selectTipo=='Reporte individual por seccion'">
              <p>Seleccione la seccion</p>
              <div class="input-group mb-3" >
                  <select class="custom-select" id="gr" [(ngModel)]="seccionSelected" >
                    <option class="d-none d-sm-block d-md-block" selected disabled="true">SELECCIONE UNA OPCION</option>
                    <ng-container *ngFor="let seccion of secciones">
                      <option [ngValue]='seccion' name="selectOption">{{seccion}}</option>
                    </ng-container>
                  </select>
              </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">Cerrar</button>
            <button  id="btnGenerar" type="button" class="btn btn-primary" (click)="exportexcel()" [disabled]="!generateReport">Generar reporte</button>
          </div>
    </ng-template>

</div>
